import React from 'react';
import {ModernTooltip, TooltipPosition} from '../../Tooltip/ModernTooltip';

export interface WithModernTooltipProps {
    tooltip?: React.ReactNode;
    position?: TooltipPosition;
    tooltipClassname?: string;
    wrapperClassname?: string;
    children?: JSX.Element;
    delay?: number;
    zIndex?: number;
    arrowOffset?: number;
    maxWidth?: number;
    tooltipOffset?: number;
    portalId?: string;
    show?: boolean;
    toggleShow?: (flag: boolean) => void;
}

export const withModernTooltip = <P extends object>(Component: React.ComponentType<P>) => {
    return (props: WithModernTooltipProps & P) => {
        return (
            <ModernTooltip {...props} className={props.tooltipClassname}>
                <Component {...props} />
            </ModernTooltip>
        );
    };
};
